import React from "react";
import classnames from "classnames";

import "./Panel.scss";

const Panel = ({ children, size = "fitParent", className }) => (
  <div className={classnames("ClickPanel", size, className)}>{children}</div>
);
export default Panel;
